import React, { Component, createRef } from 'react';
import {
    Input, Icon, Popover, Select, Radio,
} from 'antd';
import { LEAD_SOURCES } from '../../../../common/constants/leadSources';

const { Option } = Select;
const oldDivisions = new Set([LEAD_SOURCES.TBB, LEAD_SOURCES.WBABCOUK]);

const hintContent = {
    mileage: 'In the text box below, enter the motorbikes current mileage',
    previous_owner_count: 'Using the options, please let us know how many bike owners was before',
    document_history: 'Using the options, please let us know about service history',
    non_runner: 'Using the options, please let us know is bike a non runner',
    written_off: 'Using the options, please let us know has bike ever been the subject of an insurance write off',
    panniers: 'Using the options, please let us know will the bike come with panniers',
    race_replica: 'Using the options, please let us know is the bike a race replica',
    condition: 'Using the options, please let us know about bike condition',
    division: 'Using the options, please select division bike come from',
};

const formFieldStyle = {
    mainContainer: { marginTop: 5 },
    fieldStyle: { width: 428 },
    container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' },
    wrapper: { width: '100%' },
    hintContainer: { display: 'flex', alignItems: 'center', marginTop: 7 },
    hintIconStyle: { marginLeft: 10, fontSize: 18 },
    errorIconStyle: { margin: '0 5px' },
};

class BikeCondition extends Component {
    constructor(props) {
        super(props);
        this.formRef = createRef();
    }

    componentDidMount() {
        this.formRef.current.on('keyup', '[db_key]', (event) => {
            const db_key = event.target.getAttribute('db_key');
            const { value } = event.target;

            this.props.Lead_create_data.ref_bike_lead.set({ [db_key]: value });
            this.forceUpdate();
        });
    }

    handleChange = (value, path) => {
        this.props.Lead_create_data.set({ [path]: value });

        if (path === 'ref_bike_lead.panniers') {
            const bikeUpgrades = value ? [{
                ref_bike_lead_upgrades: '62f10f39a63a1be29fc4eb02', //Panniers
                _id: new mongoose.Types.ObjectId()
            },
            {
                ref_bike_lead_upgrades: '62f10f33a63a1be29fc4eb00', //Top box
                _id: new mongoose.Types.ObjectId()
            }] : [];
            
            this.props.Lead_create_data.set({ ['ref_bike_lead.upgrades']: bikeUpgrades });
        }
        
        this.forceUpdate();
    };

    render() {
        const data = this.props.Lead_create_data;
        const leadSourceCatalog = this.props.catalogs.lead_source.data.filter(division => !oldDivisions.has(division._id));
        data.validateSync();

        return (
            <div style={{ maxWidth: 470, marginBottom: 20 }} ref={this.formRef}>
                <div style={formFieldStyle.mainContainer}>
                    <h5>Division</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Select
                                db_key_select="ref_lead_source"
                                defaultValue={data.ref_lead_source && data.ref_lead_source.toString()}
                                allowClear
                                style={formFieldStyle.fieldStyle}
                                placeholder="Select Division"
                                onChange={value => this.handleChange(value, 'ref_lead_source')}
                            >
                                {leadSourceCatalog.map(division => <Option value={division._id} key={division._id}>{division.name}</Option>)}
                            </Select>
                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors.ref_lead_source
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors.ref_lead_source && data.errors.ref_lead_source.message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.division} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>
                <div style={formFieldStyle.mainContainer}>
                    <h5>Mileage?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Input
                                type="number"
                                maxLength="10"
                                placeholder="Enter mileage"
                                db_key="mileage"
                                style={formFieldStyle.fieldStyle}
                                defaultValue={data.ref_bike_lead.mileage}
                            />
                            <span
                                style={{
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.mileage']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.mileage'] && data.errors['ref_bike_lead.mileage'].message}
                            </span>

                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.mileage} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>
                <div style={formFieldStyle.mainContainer}>
                    <h5>Number of owners?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>

                            <Radio.Group
                                defaultValue={data.ref_bike_lead.previous_owner_count}
                                buttonStyle="solid"
                                onChange={e => this.handleChange(e.target.value, 'ref_bike_lead.previous_owner_count')}
                            >
                                <Radio.Button value={0}>0</Radio.Button>
                                <Radio.Button value={1}>1</Radio.Button>
                                <Radio.Button value={2}>2</Radio.Button>
                                <Radio.Button value={3}>3</Radio.Button>
                                <Radio.Button value={4}>4</Radio.Button>
                                <Radio.Button value={5}>5+</Radio.Button>
                                <Radio.Button value={undefined}>Don't know</Radio.Button>
                            </Radio.Group>

                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.previous_owner_count']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.previous_owner_count'] && data.errors['ref_bike_lead.previous_owner_count'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.previous_owner_count} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

                <div style={formFieldStyle.mainContainer}>
                    <h5>Service history?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>

                            <Radio.Group
                                defaultValue={data.ref_bike_lead.document_history}
                                buttonStyle="solid"
                                onChange={e => this.handleChange(e.target.value, 'ref_bike_lead.document_history')}
                            >
                                <Radio.Button value="Full History">Full</Radio.Button>
                                <Radio.Button value="Part History">Part</Radio.Button>
                                <Radio.Button value="No History">None</Radio.Button>
                                <Radio.Button value="First not due">First not due</Radio.Button>
                            </Radio.Group>

                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.document_history']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.document_history'] && data.errors['ref_bike_lead.document_history'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.document_history} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

                <div style={formFieldStyle.mainContainer}>
                    <h5>Is the motorbike a non-runner?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>

                            <Radio.Group
                                defaultValue={data.ref_bike_lead.non_runner}
                                buttonStyle="solid"
                                onChange={e => this.handleChange(e.target.value, 'ref_bike_lead.non_runner')}
                            >
                                <Radio.Button value="No">No</Radio.Button>
                                <Radio.Button value="Yes">Yes</Radio.Button>
                                <Radio.Button value="Just needs a battery">Needs a battery</Radio.Button>
                            </Radio.Group>

                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.non_runner']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.non_runner'] && data.errors['ref_bike_lead.non_runner'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.non_runner} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>


                <div style={formFieldStyle.mainContainer}>
                    <h5>Has your bike ever been the subject of an insurance write off?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>

                            <Radio.Group
                                defaultValue={data.ref_bike_lead.written_off}
                                buttonStyle="solid"
                                onChange={e => this.handleChange(e.target.value, 'ref_bike_lead.written_off')}
                            >
                                <Radio.Button value={false}>No</Radio.Button>
                                <Radio.Button value>Yes</Radio.Button>
                            </Radio.Group>

                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.written_off']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.written_off'] && data.errors['ref_bike_lead.written_off'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.written_off} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

                <div style={formFieldStyle.mainContainer}>
                    <h5>Will the bike come with panniers and topbox (i.e. full luggage)?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>

                            <Radio.Group
                                defaultValue={data.ref_bike_lead.panniers}
                                buttonStyle="solid"
                                onChange={e => this.handleChange(e.target.value, 'ref_bike_lead.panniers')}
                            >
                                <Radio.Button value={false}>No</Radio.Button>
                                <Radio.Button value>Yes</Radio.Button>
                            </Radio.Group>

                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.panniers']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.panniers'] && data.errors['ref_bike_lead.panniers'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.panniers} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

                <div style={formFieldStyle.mainContainer}>
                    <h5>Is the bike a race replica?</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>

                            <Radio.Group
                                defaultValue={data.ref_bike_lead.race_replica}
                                buttonStyle="solid"
                                onChange={e => this.handleChange(e.target.value, 'ref_bike_lead.race_replica')}
                            >
                                <Radio.Button value={false}>No</Radio.Button>
                                <Radio.Button value>Yes</Radio.Button>
                            </Radio.Group>

                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.race_replica']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.race_replica'] && data.errors['ref_bike_lead.race_replica'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.race_replica} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

                <div style={formFieldStyle.mainContainer}>
                    <h5>Bike condition</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Select
                                db_key_select="condition"
                                defaultValue={data.ref_bike_lead.condition}
                                allowClear
                                style={formFieldStyle.fieldStyle}
                                placeholder="Select condition"
                                onChange={value => this.handleChange(value, 'ref_bike_lead.condition')}
                            >
                                <Option key={1} value="5 - Showroom Condition">5 - Showroom Condition</Option>
                                <Option key={2} value="4 - Good">4 - Good</Option>
                                <Option key={3} value="3 - Average">3 - Average</Option>
                                <Option key={4} value="2 - Below Average">2 - Below Average</Option>
                                <Option key={5} value="1 - Very Poor">1 - Very Poor</Option>
                            </Select>
                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.condition']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_bike_lead.condition'] && data.errors['ref_bike_lead.condition'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.condition} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BikeCondition;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/components/BikeCondition.js